import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import {
  FeatureConfig,
  UpdateFeatureConfig,
} from "@reflag/shared/featureConfigAPI";

import { featureQueryKeys } from "./featureQueryKeys";

export function useFeatureConfigUpdateMutation(
  featureId: string,
  expectedVersionIds?: [string, ...string[]],
) {
  const { app } = useEnvironment();
  const queryClient = useQueryClient();

  return useMutation<
    FeatureConfig,
    AxiosError<ErrorResponse>,
    UpdateFeatureConfig
  >({
    mutationFn: (data) =>
      api
        .put<"/apps/:appId/features/:featureId/config">(
          `/apps/${app.id}/features/${featureId}/config`,
          data,
          {
            params: {
              expectedVersionIds,
            },
          },
        )
        .then((response) => response.data),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: featureQueryKeys.config(app.id, featureId),
      });
      queryClient.invalidateQueries({
        queryKey: featureQueryKeys.configVersions(app.id, featureId),
      });
    },
  });
}
